import React, { useEffect, useState } from 'react';
import css from './NotificationDropdown.module.css';
import { IconSpinner, ResponsiveImage } from '..';
import { abbreviateName, getSlugFromUrl, renderNotificationTabs } from '../../util/circleHelper';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';
import { FormattedMessage } from '../../util/reactIntl';
import NotificationContent from './NotificationContent';
import NotificationSettings from './NotificationSettings';

export default function NotificationDropdown(props) {
  const {
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onGetNotificationPreference,
    onUpdateNotificationPreference,
    onMarkAllNotificationsAsRead,
    onFetchNotifications,
    requestNotificationsInProgress,
    notificationsData,
    setIsOpen,
    onMarkNotificationRead,
    onFetchNotificationsCount,
  } = props;
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const { records = [], mongoNotifications = [] } = notificationsData || {};

  const notification = [];
  if (Array.isArray(mongoNotifications) && mongoNotifications.length) {
    mongoNotifications.forEach(item => {
      notification.push({ ...item, isMongoNotification: true });
    });
  };
  if (Array.isArray(records) && records.length) {
    records.forEach(item => {
      notification.push({ ...item, isMongoNotification: false });
    });
  };

  const [activeTab, setActiveTab] = useState(renderNotificationTabs[0]);

  const loadNotifications = () => {
    onFetchNotifications();
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const handleOnNotificationClick = item => {
    const { notifiable, action_web_url, notifiable_type } = item;
    const { space_id: spaceId, post_id: postId, id } = notifiable || {};
    const slug = getSlugFromUrl(action_web_url);

    const routesConfig = {
      Post: {
        routeName: 'PostViewPage',
        routeParams: { spaceId, slug, postId: id },
      },
      SpaceMember: {
        routeName: 'JoinedGroupsCommunityPage',
        routeParams: { id: spaceId, slug },
        queryParams: {},
      },
      Comment: {
        routeName: 'PostViewPage',
        routeParams: { spaceId, slug, postId: postId },
        queryParams: { commentId: notifiable?.parent_comment_id || id, parent_comment_id: notifiable?.parent_comment_id },
      },
      FlaggedContent: () => console.log('FlaggedContent'),
    };

    const routeConfig = routesConfig[notifiable_type];

    if (typeof routeConfig === 'function') {
      routeConfig();
    } else if (routeConfig) {
      const { routeName, routeParams, queryParams } = routeConfig;
      history.push(
        createResourceLocatorString(routeName, routeConfiguration, routeParams, queryParams)
      );
    }
    onMarkNotificationRead({ id: item.id, notificationId: item.notificationId });
    onFetchNotificationsCount();
    setIsOpen();
  };

  const mongoNotificationClick = item => {
    const { params, search, routeName } = item;
    onMarkNotificationRead({ id: item.id, notificationId: item.notificationId });
    onFetchNotificationsCount();
    setIsOpen();
    history.push(createResourceLocatorString(routeName, routeConfiguration, params, search));
  };

  const handleNotificationSettings = () => {
    setActiveTab(renderNotificationTabs[1]);
    onGetNotificationPreference();
  }

  function sortNotificationsByDate(notifications) {
    return notifications.sort((a, b) => {
      const dateA = new Date(a.createdAt || a.created_at);
      const dateB = new Date(b.createdAt || b.created_at);
      return dateB - dateA; // newest first
    });
  };

  return (
    <div>
      <div className={css.dropdown}>
        {requestNotificationsInProgress ? (
          <IconSpinner className={css.spinner} type={true} />
        ) : (
          <div className={css.tabContent}>
            <div className={css.topWrapper}>
              <div
                className={css.notificationHeading}
                onClick={() => setActiveTab(renderNotificationTabs[0])}
              >
                <FormattedMessage id="CircleFeedPage.notifications" />
              </div>
              <div className={css.iconWrapper}>
                <div className={css.iconSetting} onClick={onMarkAllNotificationsAsRead}><ProfileIconCard type="mark" />
                  <span className={css.tooltipText}>Mark as Read</span>
                </div>
               { activeTab.id == renderNotificationTabs[1].id  ? <div className={css.iconSetting} onClick={(e)=>{
                e.preventDefault();
                setActiveTab(renderNotificationTabs[0]);
               }}>
                  <ProfileIconCard type="notification_mobile" />
                  <span className={css.tooltipText}>Notifications</span>
                </div>
                : <div className={css.iconSetting} onClick={handleNotificationSettings}>
                  <ProfileIconCard type="settings" />
                  <span className={css.tooltipText}>Setting</span>
                </div> }
              </div>
            </div>
            <div className={css.spacer}></div>
            {activeTab.id === renderNotificationTabs[0].id ? (
              <>
                <NotificationContent
                  records={sortNotificationsByDate(notification)}
                  handleOnNotificationClick={handleOnNotificationClick}
                  mongoNotificationClick={mongoNotificationClick}
                />
              </>

            ) : (
              <NotificationSettings
                requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
                notificaitonPreferenceData={notificaitonPreferenceData}
                onUpdateNotificationPreference={onUpdateNotificationPreference}
              />
            )}
            {/* <div className={css.dropdownScroll}>
                            {Array.isArray(records)
                                ? records?.map(item => (
                                    <div className={css.dropdownData} key={item.id} onClick={() => handleOnNotificationClick(item)}>
                                        <div className={css.dropDownData}>
                                            <div className={css.imageleft}>
                                                {item?.actor_image ? (
                                                    <ResponsiveImage imagewithURL={item?.actor_image} />
                                                ) : (
                                                    <div className={css.nameWrapper}>{abbreviateName(item.actor_name)}</div>
                                                )}
                                            </div>
                                            <div className={css.notificationRight}>
                                                <div className={css.notificationText}>
                                                    {item.notification_text_structure?.map((key, index) => {
                                                        const value = item[key];
                                                        return value ? (
                                                            <span key={index} className={css[key]}>
                                                                {value} {' '}
                                                            </span>
                                                        ) : null;
                                                    })}
                                                </div>
                                                <div>
                                                    {!item?.read_at ? <ProfileIconCard type="green" /> : <ProfileIconCard type="dot_empty" />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                : null}
                        </div> */}
          </div>
        )}
      </div>
    </div>
  );
}
